import {
    FETCH_NOTIFICATIONS,
    FETCH_NOTIFICATIONS_SUCCESS,
    FETCH_NOTIFICATIONS_FAILED,
    EDIT_NOTIFICATIONS,
    SEND_NOTIFICATION,
    SEND_NOTIFICATION_SUCCESS,
    SEND_NOTIFICATION_FAILED,
} from "../store/types";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from "../config/configureFirebase";
import { onValue, set, push, remove } from "firebase/database";
import store from "../store/store";
import { Platform } from "react-native";

export const fetchUserNotifications = () => (dispatch) => {
    const { auth, userNotificationsRef } = firebase;

    dispatch({
        type: FETCH_NOTIFICATIONS,
        payload: null,
    });

    const uid = auth.currentUser.uid;

    onValue(userNotificationsRef(uid), (snapshot) => {
        const data = snapshot.val();
        if (data) {
            const arr = Object.keys(data).map((i) => {
                data[i].id = i;
                return data[i];
            });
            dispatch({
                type: FETCH_NOTIFICATIONS_SUCCESS,
                payload: arr.reverse(),
            });
        } else {
            dispatch({
                type: FETCH_NOTIFICATIONS_FAILED,
                payload: "No data available.",
            });
        }
    });
};

export const fetchNotifications = () => (dispatch) => {
    const { notifyRef } = firebase;

    dispatch({
        type: FETCH_NOTIFICATIONS,
        payload: null,
    });
    onValue(notifyRef, (snapshot) => {
        if (snapshot.val()) {
            const data = snapshot.val();

            const arr = Object.keys(data).map((i) => {
                data[i].id = i;
                return data[i];
            });

            // Sort notifications by timestamp/createdAt in descending order (latest first)
            const sortedArr = arr.sort((a, b) => {
                // Try to use createdAt first, then fallback to timestamp, then to id (Firebase key)
                const timeA = a.createdAt
                    ? new Date(a.createdAt).getTime()
                    : a.timestamp
                    ? new Date(a.timestamp).getTime()
                    : parseInt(a.id) || 0;
                const timeB = b.createdAt
                    ? new Date(b.createdAt).getTime()
                    : b.timestamp
                    ? new Date(b.timestamp).getTime()
                    : parseInt(b.id) || 0;

                return timeB - timeA; // Descending order (latest first)
            });

            dispatch({
                type: FETCH_NOTIFICATIONS_SUCCESS,
                payload: sortedArr,
            });
        } else {
            dispatch({
                type: FETCH_NOTIFICATIONS_FAILED,
                payload: "No data available.",
            });
        }
    });
};

export const editNotifications = (notification, method) => (dispatch) => {
    const { notifyRef, notifyEditRef } = firebase;
    dispatch({
        type: EDIT_NOTIFICATIONS,
        payload: { method, notification },
    });
    if (method === "Add") {
        // Add timestamp when creating new notification
        const notificationWithTimestamp = {
            ...notification,
            createdAt: new Date().toISOString(),
            timestamp: new Date().getTime(),
        };
        push(notifyRef, notificationWithTimestamp);
    } else if (method === "Delete") {
        remove(notifyEditRef(notification.id));
    } else {
        set(notifyEditRef(notification.id), notification);
    }
};

export const sendNotification = (notification) => async (dispatch) => {
    console.log(`[Notification Debug] Sending notification:`, {
        title: notification.title,
        usertype: notification.usertype,
        devicetype: notification.devicetype,
        body: notification.body,
    });

    dispatch({
        type: SEND_NOTIFICATION,
        payload: notification,
    });

    const users = store.getState().usersdata.users;
    if (users) {
        let arr = [];
        console.log(`[Notification Debug] Processing ${users.length} users`);

        for (let i = 0; i < users.length; i++) {
            let usr = users[i];
            let obj = {
                to: null,
                title: notification.title,
                msg: notification.body,
            };

            // Fix: Handle both 'All' and 'Ambos' (Spanish translation) for device type
            // Also handle various other potential translation variations
            const isAllDeviceTypes = [
                "All",
                "Ambos",
                "all",
                "ambos",
                "TODO",
                "todo",
                "Todos",
                "todos",
            ].includes(notification.devicetype);
            const isAllUserTypes = [
                "All",
                "Ambos",
                "all",
                "ambos",
                "TODO",
                "todo",
                "Todos",
                "todos",
            ].includes(notification.usertype);

            // Additional safety check for exact device platform matching
            const deviceMatches =
                isAllDeviceTypes ||
                usr.userPlatform === notification.devicetype ||
                (notification.devicetype === "ANDROID" &&
                    usr.userPlatform === "android") ||
                (notification.devicetype === "IOS" &&
                    usr.userPlatform === "ios") ||
                (notification.devicetype === "android" &&
                    usr.userPlatform === "ANDROID") ||
                (notification.devicetype === "ios" &&
                    usr.userPlatform === "IOS");

            const userTypeMatches =
                isAllUserTypes || usr.usertype === notification.usertype;

            if (userTypeMatches && deviceMatches) {
                if (usr.pushToken) {
                    obj.to = usr.pushToken;
                    arr.push(obj);
                    console.log(
                        `[Notification Debug] Added user ${usr.firstName} (${usr.usertype}, ${usr.userPlatform})`
                    );
                }
            }
        }

        console.log(
            `[Notification Debug] Total notifications to send: ${arr.length}`
        );

        if (arr.length > 0) {
            for (let x = 0; x < arr.length; x++) {
                RequestPushMsg(arr[x].to, {
                    title: arr[x].title,
                    msg: arr[x].msg,
                    channelId: "general",
                    sound:
                        Platform.OS === "android" ? "general" : "general.mp3", // Correct format for each platform
                });
            }
            dispatch({
                type: SEND_NOTIFICATION_SUCCESS,
                payload: arr,
            });
        } else {
            dispatch({
                type: SEND_NOTIFICATION_FAILED,
                payload:
                    store.getState().languagedata.defaultLanguage.no_user_match,
            });
        }
    } else {
        dispatch({
            type: SEND_NOTIFICATION_FAILED,
            payload:
                store.getState().languagedata.defaultLanguage.no_user_match,
        });
    }
};
